import { useSelector } from "react-redux";

export default function Chat() {
    // const urlCIP = process.env.REACT_APP_URL_CIP; 691c612c1eaa66082ea86165
    const user = useSelector((state: any) => state?.account?.user);
    // const urlCIP = `https://cip.vamsolucoes.com/${user?._id}/armed?sidebar=false`;
    // const urlCIP = 'https://cip.vamsolucoes.com/login-instituicao/691c61c51eaa66082ea861af/ofa?sidebar=true'; 

    // const urlCIP = `http://localhost:5173/${user?._id}/armed?sidebar=false`;
    const urlCIP = `http://localhost:5173/login-instituicao/${user?._id}/armed?sidebar=true`;
    return <iframe title='Chat Instituçional Publico' src={urlCIP} width={'100%'} height={'94%'} style={{ border: 'none', background: '#fff', marginTop: 5, borderRadius: 5 }} />
}
